import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import {PayWithCard} from "./PayWithCard"
import {NexiPayWithCard} from "./NexiPayWithCard"
import MoveToWorkQueue from "../MoveToWorkQueue/MoveToWorkQueue"
import PayOnline from "./PayOnline"
import PaymentMethodSelection from "./PaymentMethodSelection"
import ReservationPaymentDone from "./ReservationPaymentDone";
import {ServiceCardType} from "../Types";
import { DateTime } from 'luxon'
import { getLocale } from '../../../Utils/helpers'
import {RootState} from '../../../Redux'

interface PaymentProps {
    serviceCard: ServiceCardType
    setServiceCard: (serviceCard: ServiceCardType) => void
    driveIn: boolean
    initialPayWithCard?: boolean
    onBack: () => void
}

const Payment = ({ serviceCard, setServiceCard, driveIn, initialPayWithCard, onBack }: PaymentProps) => {
    const nexiTerminalId = useSelector((state: RootState) => state.ui.settings.selfService.nexiTerminalId)
    const [payWithCard, setPayWithCard] = useState<boolean|null>(initialPayWithCard ?? null)

    const [paymentMade, setPaymentMade] = useState<boolean|null>(null)

    if (! serviceCard) {
        return null
    }

    const locale = getLocale()
    const reservation = serviceCard.sale ?? serviceCard.reservation
    const date = DateTime.fromISO(
        reservation.tasks[0].event.duration.start,
        {setZone: true}
    ).setLocale(locale)

    // if reservation in 2 hours
    const diffMs = date.toMillis() - DateTime.now().toMillis()
    const toWorkQueue = date.isValid && diffMs > 0 && diffMs < 2 * 60 * 60 * 1000

    const afterPaymentView =
        (driveIn === true || toWorkQueue === true)
            ? <MoveToWorkQueue serviceCard={serviceCard} paymentDone={paymentMade} />
            : <ReservationPaymentDone serviceCard={serviceCard} />

    return (<>
        {paymentMade === null && <>
            {payWithCard === null && <>
                {serviceCard && serviceCard.sale &&
                    <PaymentMethodSelection
                        serviceCard={serviceCard}
                        setPayWithCard={setPayWithCard}
                        onBack={onBack}
                    />
                }
            </>}
            {payWithCard === false &&
                <PayOnline
                    serviceCard={serviceCard}
                    setServiceCard={setServiceCard}
                    setPaymentMade={setPaymentMade}
                    onBack={onBack}
                />
            }
            {payWithCard === true && !nexiTerminalId &&
                <PayWithCard
                    serviceCard={serviceCard}
                    setServiceCard={setServiceCard}
                    setPaymentMade={setPaymentMade}
                    onBack={onBack}
                />
            }
            {payWithCard === true && nexiTerminalId &&
                <NexiPayWithCard
                    serviceCard={serviceCard}
                    setServiceCard={setServiceCard}
                    setPaymentMade={setPaymentMade}
                    onBack={onBack}
                />
            }
        </>}
        {paymentMade === true && afterPaymentView}
    </>)
}

export default Payment
